import { AnimatePresence, motion } from "framer-motion";

export const BurgerCustom = ({ setIsOpen, isOpen }) => {

    const handleClick = () => {
        setIsOpen(!isOpen);
    }
    
    return (
        <button onClick={handleClick} className="text-[#FF5101] z-20 w-12  text-lg font-medium flex items-center justify-center gap-2 relative">

            <motion.div 
                className="flex items-center justify-center absolute w-8 h-8"
                initial={{ opacity:0 }}
                animate={{ opacity:isOpen ? 1:0 }}    
            >
                <motion.span 
                    initial={{rotate:0}}
                    animate={{rotate:isOpen ? 45 : 0}}
                    exit={{ rotate:0}}
                    transition={{ type:"spring", stiffness:400, damping:50, ease:"linear"}}
                    className="block absolute h-[2px] w-8 bg-[#FF5101]"
                ></motion.span>
                <motion.span 
                    initial={{opacity:0, rotate:0}}
                    animate={{opacity:isOpen ? 1 : 0, rotate:isOpen ? -45 : 0}}
                    exit={{ rotate:0}}
                    transition={{ type:"spring", stiffness:400, damping:50, ease:"linear"}}
                    className="block absolute h-[2px] w-8 bg-[#FF5101]"
                ></motion.span>
            </motion.div>
            
            <AnimatePresence initial={false}>
                {!isOpen && 
                    <motion.span 
                        initial={{ opacity:1, scale:1}}
                        animate={{ opacity: !isOpen ? 1 : 0, scale:!isOpen ? 1 : 0}}
                        exit={{ opacity: !isOpen ? 0 : 1, scale:!isOpen ? 1 : 0 }}
                        transition={{ type:"spring", duration:.5, ease:"linear"}} 
                        className="block order-first"
                    >Menu</motion.span>
                }
            </AnimatePresence>
            
        </button>
    )
}